import { orderOnLevel } from '../utils/sort'
import { getRequestGateway } from '@/services/api.service'

export async function getFloorPlansForLevelV1(id) {
  return getRequestGateway('core/v1/levels/' + id + '/floorplans')
}

export async function getLevelv1(id) {
  return getRequestGateway('core/v1/levels/' + id)
}

export async function getLevelsv1(id) {
  return getRequestGateway('core/v1/levels?constructionId=' + id)
}

export async function getLevelsGeoV1(id) {
  return getRequestGateway('core/v1/levels/geojson?constructionId=' + id)
}

export async function getLevelsForBuilding(
  buildingId,
  buildingGeometry,
  getFloorPlans = true,
  bypassGeometry = false
) {
  try {
    const levelsData = await getLevelsGeoV1(buildingId)
    if (!levelsData && !bypassGeometry) return null
    const response = await getLevelsv1(buildingId)
    let levels = levelsData.data.length
      ? levelsData.data
      : response.data.map((level) => ({
          id: level.id,
          geometry: undefined,
          properties: level
        }))
    let levelGeojson = {
      type: 'geojson',
      data: {
        id: 'sourceLevel',
        type: 'FeatureCollection',
        features: []
      }
    }
    const responseGeojson = levelsData
    const features = response.data
    const featuresGeojson = responseGeojson.data
    featuresGeojson.forEach((level) => {
      const feature = features.find((feature) => feature.id === level.properties.belongsToId)
      if (feature) level.properties = feature // Replacing properties in geojson response with content from the constructions endpoint
    })
    levels.sort(orderOnLevel)
    if (levels[8] && levels[8].properties.belongsToId === '834089315160051712') {
      // Exception for level 8, building 834089140215631872: removing level
      levels.splice(8, 1)
    }
    let additionalHeight = 0 // Used when extra level height is added
    let counter = 0
    let gapHeight = 0.5 // Height of the gap between levels
    let currentElevation = 0 // Tracks the elevation for when the elevation property is missing for a level
    let minElevation // Stores the minElevation to subtract from all levels elevation height (the map is located at 0 m so we want the building's lowest point to be positioned there)
    levels = levels.map((level) => {
      if (!level.geometry) {
        level.geometry = buildingGeometry
      }
      level.id = level.properties.id
      level.properties.belongsToId = level.properties.id

      if (getFloorPlans) {
        getFloorPlansForLevelV1(level.id).then((floorplans) => {
          level.properties.hasFloorPlans = floorplans ? floorplans.data : []
        })
      }
      if (counter === 0) {
        // For the first level only
        if (!level.properties.elevation) {
          level.properties.elevation = 0 // If elevation property is missing set it to 0
        }
        minElevation = level.properties.elevation // minElevation is based on the bottom level's elevation
        level.properties.elevation -= minElevation // Make the first level in the array begin from 0 m
      } else {
        // For the following levels
        if (!level.properties.elevation) {
          level.properties.elevation = currentElevation
        } else {
          level.properties.elevation -= minElevation // The elevation is where the volume's lower edge begins
          level.properties.elevation += gapHeight + additionalHeight // Here we add some distance from the volume below each level, and additionalHeight if level heights have been increased
        }
      }
      if (!level.properties.height) {
        level.properties.height = 3 // Adding level height if property is missing
      }
      if (level.properties.height < 3) {
        // This makes sure that the levels are at least 3 m high
        let newHeight = level.properties.elevation + 3
        additionalHeight += newHeight - level.properties.height // Tracks the additional height to be able to properly set the new elevation for following levels
        level.properties.height = newHeight
      } else {
        level.properties.height = level.properties.elevation - gapHeight + level.properties.height // Subtract gapHeight from the height since we added gapHeight to the elevation
      }
      currentElevation = level.properties.height + gapHeight
      counter++
      return level
    })
    levelGeojson.data.features = levels
    return levelGeojson
  } catch (e) {
    console.error(e)
    throw new Error('Could not fetch levels')
  }
}
